import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { IMAGENES, MONEDA, PRECIO, PRECIO_ANTERIOR } from '../data/landing';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-crema pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-74" data-mp="9l33na9io82x">
      <div className="pointer-events-none absolute -right-24 top-40 h-64 w-64 rounded-full bg-rosa-50 blur-3xl" aria-hidden="true" data-id="element-75" data-mp="4njp098wptag" />

      <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-8 px-5 sm:px-8 lg:grid lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-76" data-mp="xano5xlbjdeb">
        {/* Texto superior: etiqueta + titular */}
        <motion.div className="order-1 w-full text-center lg:order-none lg:text-left" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-77" data-mp="nc85mj0cxcgf">
          

          <h1 className="mt-5 font-serif text-3xl leading-tight text-borgona sm:text-5xl lg:text-[3.25rem] lg:leading-[1.15]" data-id="element-78" data-mp="384s5oprwen3l">
            Descubrí el arte de bordar sobre papel y{' '}
            <em className="font-script not-italic text-terracota" data-id="element-79" data-mp="3o5j3nbh1flmc">
              creá piezas hermosas desde cero
            </em>
          </h1>

          <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-suave sm:text-xl lg:mx-0" data-id="element-80" data-mp="3e8whmjcz6oiq">
            Una técnica simple y relajante, paso a paso, incluso si nunca
            bordaste antes.
          </p>

          {/* Precio + CTA: en mobile aparecen debajo de la imagen */}
          <div className="order-3 mt-8 hidden flex-col items-center gap-3 lg:flex lg:items-start" data-id="element-81" data-mp="2qkmsp8kgtknd">
            <PrecioYCta data-id="element-82" data-mp="2vi54r7ts4fzl" />
          </div>
        </motion.div>

        {/* Imagen del producto: en mobile va por encima del botón */}
        <motion.div className="order-2 mx-auto w-full max-w-[19rem] sm:max-w-sm lg:order-none lg:max-w-md" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-83" data-mp="2hjoxnfs08ngx">
          <img src={IMAGENES.portada} alt="Portada del curso Puntadas de Papel de Deco Emprende" className="relative w-full rounded-3xl border-4 border-white shadow-suave" data-id="element-84" data-mp="n9i4pev29iv6" />
        </motion.div>

        <div className="order-3 flex w-full flex-col items-center gap-3 lg:hidden" data-id="element-85" data-mp="db2fjhflgjob">
          <PrecioYCta data-id="element-86" data-mp="1b04bl2tbwx3l" />
        </div>
      </div>
    </section>;
}
function PrecioYCta() {
  return <>
      <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1" data-id="element-87" data-mp="162m47guympxp">
        <span className="font-sans text-base text-suave line-through decoration-terracota/60" data-id="element-88" data-mp="11152jj4nizg2">
          {PRECIO_ANTERIOR}
        </span>
        <span className="font-sans text-xs font-bold uppercase tracking-widest text-frambuesa" data-id="element-89" data-mp="3lsyun4p58wlp">
          Hoy
        </span>
        <span className="font-serif text-4xl text-borgona sm:text-5xl" data-id="element-90" data-mp="3hr3tc077qj7x">
          {PRECIO}
        </span>
        <span className="font-sans text-sm font-semibold text-suave" data-id="element-91" data-mp="1xa43telg8kjm">
          {MONEDA}
        </span>
      </div>

      <CTAButton className="mt-1" data-id="element-92" data-mp="21bpo3l0bc13u">Quiero aprender</CTAButton>

      <p className="font-sans text-sm text-suave" data-id="element-93" data-mp="26a98vi3676um">
        Acceso inmediato · Producto 100% digital
      </p>

      <div className="flex items-center gap-2" data-id="element-94" data-mp="2b192oegzt8sw">
        <span className="flex" aria-hidden="true" data-id="element-95" data-mp="2b20tzd3k4kdd">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-terracota text-terracota" data-id="element-96" data-mp="2fz101o0epn4h" />)}
        </span>
        <span className="font-sans text-sm text-suave" data-id="element-97" data-mp="2kxkj9gnm8kt5">
          +2.000 mujeres ya crean con nosotras
        </span>
      </div>
    </>;
}